import request from '../../axios/axiosconfig.js'

export function getAllCsDeviceApply(params) {
  return request({
    url: '/ps/csDeviceApply/getAllCsDeviceApply',
    method: 'get',
    params: params
  })
}

export function getCsDeviceApplyDetail(params) {
  return request({
    url: '/ps/csDeviceApply/getCsDeviceApplyDetail/' + params,
    method: 'get'
  })
}

export function approvalApply(data) {
  return request({
    url: '/ps/csDeviceApply/approvalApply',
    method: 'post',
    data: data
  })
}

export function revoke(data) {
  return request({
    url: '/ps/csDeviceApply/revoke',
    method: 'post',
    data: data
     
  })
}

export function refuse(data) {
  return request({
    url: '/ps/csDeviceApply/refuse',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/apply/approvalapply.js